export const BathRuleMock = [
  {
    "id": "0",
    "type": { "code": "NONE", "text": "なし" },
    "priority": "0"
  },
  {
    "id": "1",
    "type": { "code": "MEN_FIRST", "text": "男性が先" },
    "priority": "1"
  },
  {
    "id": "2",
    "type": { "code": "WOMEN_FIRST", "text": "女性が先" },
    "priority": "2"
  }
]

export function convertToBathRuleXml(rules: any[]): string {
  let xml = `<RuleSet>\n`;

  for (const rule of rules) {
    const idAttr = `id="${rule.id}"`;
    const selectedAttr = rule.selected ? ` selected="${rule.selected}"` : "";
    const typeCode = rule.type?.code || "";
    const typeText = rule.type?.text || "";
    const priority = rule.priority || "";

    xml += `<Rule ${idAttr}${selectedAttr}>`;
    xml += `<Type code="${typeCode}">${typeText}</Type>`;
    xml += `<Priority>${priority}</Priority>`;
    xml += `</Rule>`;
  }

  xml += `</RuleSet>`;
  return xml;
}

export function bathRuleToJson(xmlStr:string) {
  if(!xmlStr || xmlStr == "") return BathRuleMock;
  
  const parser = new DOMParser();
  const xmlDoc = parser.parseFromString(xmlStr, "text/xml");

  const rules = Array.from(xmlDoc.getElementsByTagName("Rule")).map(rule => {
    const id = rule.getAttribute("id");
    const selected = rule.getAttribute("selected") || null;

    const typeNode = rule.getElementsByTagName("Type")[0];
    const priorityNode = rule.getElementsByTagName("Priority")[0];

    const type = {
      code: typeNode?.getAttribute("code"),
      text: typeNode?.textContent?.trim()
    };

    const priority = priorityNode?.textContent?.trim();

    return { id, selected, type, priority };
  });

  return rules;
}